// extracted by mini-css-extract-plugin
export default {"r_l":"_5a9f99ffb9 _5018b90d97","t":"_4b005667f1"};